import './Footer.scss';
import contactInfo from '../contact-info.json';

const currentYear = new Date().getFullYear();

export function Footer() {
  return (
    <footer className="App-footer">
      <div className="footer-info">
        <div className="company-info">
          <p className="lato-thin name">Lilia Facialiste</p>
          <p className="lato-thin">
            {contactInfo.phone} | {contactInfo.email}
          </p>
        </div>
        <div className="legal">
          <a href="/mentions-legales">Mentions légales</a>
        </div>
      </div>
      <p className="copyright">© Lilia Facialiste EI | {currentYear}</p>
    </footer>
  );
}
